// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t1TW","badges":"styles_badges__13-Y_"};